import React, {Component} from 'react';
import {Link} from "react-router-dom";
import {StatusToggl} from "../StatusToggl";
import {getTypesData} from "../business_units/BusinessUnitTypes";
import {COLUMN_CELL_INVALID_CONTENT, getMetricName} from "../dashboard/columns";
import {ChannelLogo} from "../channels/ChannelLogo";
import {FACEBOOK_CHANNEL, GOOGLE_CHANNEL, SHEET_CHANNEL, TIKTOK_CHANNEL, LINKEDIN_CHANNEL, SHOPIFY_CHANNEL, TIENDA_NUBE_CHANNEL, ANALYTICS_CHANNEL, WOOCOMMERCE_CHANNEL, VTEX_CHANNEL} from "../channels/channels";
import {
    FORMAT_METRIC_VALUE,
    PROPERTIES_FOR_METRIC
} from "../dashboard/metrics";
import {Alert} from "reactstrap";
import { withTranslation } from 'react-i18next';


class BusinessUnitRowClass extends Component {
    static action_activate = 'activate';
    static action_deactivate = 'deactivate';

    constructor(props) {
        super(props);
        this.handleBusinessUnitStatusChange = this.handleBusinessUnitStatusChange.bind(this);
        this.handleBusinessUnitDelete = this.handleBusinessUnitDelete.bind(this);
    }

    handleBusinessUnitDelete() {
        this.props.onDelete(this.props.businessUnit.id)
    }

    handleBusinessUnitStatusChange(shouldActivate) {
        const action = shouldActivate ? BusinessUnitRowClass.action_activate : BusinessUnitRowClass.action_deactivate;
        this.props.onStatusChange(this.props.businessUnit.id, action)
    }

    render() {
        return (
            <tr key={this.props.businessUnit.id}>
                <td><Link to={`/business-unit/${this.props.businessUnit.id}/`}>{this.props.businessUnit.name}</Link>
                </td>
                <td className="channel-cell">
                    <div>
                        {this.renderGoogleAdsIcon()}
                        {this.renderFacebookIcon()}
                        {this.renderSheetIcon()}
                        {this.renderTiktokAdsIcon()}
                        {this.renderLinkedinAdsIcon()}
                        {this.renderShopifyIcon()}
                        {this.renderTiendaNubeIcon()}
                        {this.renderWooCommerceIcon()}
                        {this.renderVtexIcon()}
                        {this.renderAnalyticsIcon()}
                    </div>
                </td>
                <td>{this.renderPeriod()}</td>
                <td>{this.renderType()}</td>
                <td>{this.renderBudgetValue()}</td>
                <td>{this.renderGoalsCell()}</td>
                <td className="status-cell">
                    <StatusToggl onChange={this.handleBusinessUnitStatusChange} active={this.props.businessUnit.active}
                                 onDelete={this.handleBusinessUnitDelete}
                                 title={"Eliminar una línea de control"}
                                 message={"Se eliminará la línea de control"}
                                 question={"¿desea continuar?"}
                    />
                </td>
            </tr>
        );
    }

    renderGoalItem(index, goalData) {
        const { t } = this.props;
        return <div key={`goal-${index}`} className="goal-item">{`${index}. ${getMetricName(t, goalData.metric_name)} = ${FORMAT_METRIC_VALUE(goalData.metric_name, goalData.value)}`}</div>;
    }

    renderCampaignsAdgroupsGoalsItem(count) {
        const { t } = this.props;
        return <div key="campaign-goals" className="goal-item">{`+ ${t('business_unit_row.campaigns_and_adgroups')} = ${count} ${t('business_unit_row.goals')}`}</div>;
    }

    renderGoalsCell() {
        const goals = this.props.businessUnit.goals_data;

        if(goals.business_unit_goals.length === 0 && goals.campaigns_goals.length === 0 && goals.adgroups_goals.length === 0){
            const { t } = this.props;
            return <Alert className="alert-label alert-warning">{t('business_unit_row.no_goals')}</Alert>;
        }

        let index = 1;
        const itemsToRender = [];
        goals.business_unit_goals.forEach((goal) => {
            itemsToRender.push(this.renderGoalItem(index, goal));
            index = index + 1;
        });

        if (goals.campaigns_goals.length > 0 || goals.adgroups_goals.length > 0)
        {
            const count = goals.campaigns_goals.length + goals.adgroups_goals.length;
            itemsToRender.push(this.renderCampaignsAdgroupsGoalsItem(count))
        }

        return <div className="goal-items">{itemsToRender}</div>
    }

    renderBudgetValue() {
        if (this.props.businessUnit.allocated_budget !== null) {
            const formattedValue = Number(this.props.businessUnit.allocated_budget).toLocaleString('en-US');
            return this.props.businessUnit.budget_currency + " " + formattedValue;
        }
        const { t } = this.props;
        return <Alert className="alert-label alert-warning">{t('business_unit_row.no_budget')}</Alert>;
    }

    renderPeriod() {
        if (!this.props.businessUnit.period_type)
            return COLUMN_CELL_INVALID_CONTENT;
        
        if(this.props.businessUnit.period_type === "Mensual")
            return this.props.businessUnit.period_type
        else
            return this.props.businessUnit.period_type + ": "+this.props.businessUnit.period_first_date+" a "+this.props.businessUnit.period_last_date
    }

    renderType() {
        const { t } = this.props;
        const typesData = getTypesData(t);
        return typesData[this.props.businessUnit.type]["Short"];
    }

    renderGoogleAdsIcon() {
        if (this.props.businessUnit.has_google_channel) {
            return <ChannelLogo channel={GOOGLE_CHANNEL}  useOld={true} hspace={0} />
        }
    }

    renderTiktokAdsIcon() {
        if (this.props.businessUnit.has_tiktok_channel) {
            return <ChannelLogo channel={TIKTOK_CHANNEL}  useOld={true} useLogoImageWithPadding={true} hspace={0} width={30} height={30} />
        }
    }

    renderLinkedinAdsIcon() {
        if (this.props.businessUnit.has_linkedin_channel) {
            return <ChannelLogo channel={LINKEDIN_CHANNEL} renderVeryColoredVersion={true}  hspace={0} width={17} height={17} marginLeft={8} padding={0} />
        }
    }

    renderFacebookIcon() {
        if (this.props.businessUnit.has_facebook_channel) {
            return <ChannelLogo channel={FACEBOOK_CHANNEL} hspace={0} />
        }
    }
    renderSheetIcon() {
        if (this.props.businessUnit.has_sheet_channel) {
            return <ChannelLogo channel={SHEET_CHANNEL} styles={{marginLeft:'15px', width: '22px', height: '22px'}} />
        }
    }

    renderShopifyIcon() {
        if (this.props.businessUnit.has_shopify_channel) {
            return <ChannelLogo channel={SHOPIFY_CHANNEL} hspace={0} width={20} height={20} />
        }
    }

    renderTiendaNubeIcon() {
        if (this.props.businessUnit.has_tienda_nube_channel) {
            return <ChannelLogo channel={TIENDA_NUBE_CHANNEL} hspace={0} width={20} height={20} />
        }
    }

    renderWooCommerceIcon() {
        if (this.props.businessUnit.has_woocommerce_channel) {
            return <ChannelLogo channel={WOOCOMMERCE_CHANNEL} hspace={0} width={20} height={20} />
        }
    }

    renderVtexIcon() {
        if (this.props.businessUnit.has_vtex_channel) {
            return <ChannelLogo channel={VTEX_CHANNEL} hspace={0} width={20} height={20} />
        }
    }

    renderAnalyticsIcon() {
        if (this.props.businessUnit.has_analytics_channel) {
            return <ChannelLogo channel={ANALYTICS_CHANNEL} hspace={0} width={25} height={25} marginLeft={5} />
        }
    }
}

export const BusinessUnitRow = withTranslation()(BusinessUnitRowClass);
export default BusinessUnitRow;
